import { mapKeys } from "lodash";
import {
  getCommonUserProps,
  getDeviceProp,
  getEventNameByKey,
} from "../helpers/SegmentHelpers";
import { segmentProps } from "../helpers/SegmentProperties";

export const trackEvent = async ({ eventNameKey, analytics, props = {} }) => {
  // device information gets added with every track event
  let localProps = {
    ...props,
    ...getDeviceProp(),
  };

  // source gets added with every track event
  if (!localProps?.source) {
    localProps.source = window.location.pathname;
  }

  if (localProps) {
    localProps = JSON.parse(
      JSON.stringify(localProps, (_, v) => (v === undefined ? null : v))
    );
  }

  // mapping props key to constant file
  if (Object.keys(localProps).length > 0) {
    localProps = mapKeys(localProps, (v, k) => segmentProps[k]);
  }

  // fetching event name which is stored in redux state by its key
  const eventName = getEventNameByKey(eventNameKey);

  if (eventName) {
    const response = await analytics.track(eventName, localProps);
    return response;
  }

  return null;
};

export const identifyEvent = async ({
  traits,
  userId,
  replaceUndefinedOrNullValues,
  analytics,
  user,
}) => {
  let localTraits = {
    ...traits,
    ...getDeviceProp(), // adding device details into traits
    ...getCommonUserProps(user),
  };

  if (localTraits) {
    if (replaceUndefinedOrNullValues) {
      localTraits = JSON.parse(
        JSON.stringify(localTraits, (_, v) =>
          v === undefined || v === null ? "" : v
        )
      );
    }
  }

  localTraits = mapKeys(localTraits, (v, k) => segmentProps[k]);

  await analytics.identify(userId, localTraits);
};
